import { SearchContext } from '~/components/SearchBuilder/utils/searchUtils';
import TextField from '~/components/TextField';

const ValueNumber = ({ className, value, onChange }) => {
  const { disabled } = useContext(SearchContext);
  return (
    <TextField
      disabled={disabled}
      type="number"
      variant="outlined"
      FormControlProps={{ className }}
      value={value}
      placeholder="Enter a number"
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

ValueNumber.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

export default ValueNumber;
